import { translate } from "../common";



/**
 * Provides a helper to update the browser tab title with the Fabrix prefix.
 * @returns Function that sets the document title for the supplied page name.
 */
export function useTabTitle() {


    /**
     * Sets the document title including the NT Portal prefix.
     * @param pageName - Page label to append to the tab title.
     */
    const setTitle = (pageName: string) => {
        document.title = `${translate('NT_PORTAL')} > ${pageName}`
    }

    return setTitle;
}